/**
 * Handles the display of reveal.js' optional slide title stack.
 */
export default class SectionTitle {

	constructor( Reveal ) {

		this.Reveal = Reveal;

	}

	render() { 

		this.element = document.createElement( 'h4' );
		this.element.className = 'title-stack uppercase text-gray-400 dark:text-gray-500 tracking-wider';
		this.Reveal.getRevealElement().appendChild( this.element );

	}

	/**
	 * Called when the reveal.js config is updated.
	 */
	configure( config, oldConfig ) {

		let sectionTitleDisplay = 'none';
		if( config.sectionTitle && !this.Reveal.isPrintingPDF() ) {
      sectionTitleDisplay = 'block';
		}

		this.element.style.display = sectionTitleDisplay;

	}

	/**
	 * Updates the title stack to match the current slide.
	 */
	update() {

		// Update title stack if enabled
		if( this.Reveal.getConfig().sectionTitle && this.element ) {
			this.element.innerHTML = this.getSectionTitle();
		}

	}

	/**
	 * Returns the HTML string corresponding to the current stack title
	 */
	getSectionTitle() {

		let title = document.querySelector(".stack.present").getAttribute( 'data-titre' );

		return title;

	}


}